import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-post",
  "use": "icon-post-usage",
  "viewBox": "0 0 128 128",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 128 128\" id=\"icon-post\">\n  <rect x=\"30\" y=\"40\" width=\"68\" height=\"48\" rx=\"8\" fill=\"currentColor\" opacity=\"0.3\" />\n  <rect x=\"40\" y=\"30\" width=\"48\" height=\"8\" rx=\"4\" fill=\"currentColor\" opacity=\"0.8\" />\n  <circle cx=\"64\" cy=\"64\" r=\"12\" fill=\"currentColor\" opacity=\"0.7\" />\n  <rect x=\"20\" y=\"100\" width=\"88\" height=\"8\" rx=\"4\" fill=\"currentColor\" opacity=\"0.5\" />\n  <polygon points=\"64,20 70,30 58,30\" fill=\"currentColor\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol